/** @graphql cc **/
import gql from 'graphql-tag';

export const GetPersonalSpaceKeyQuery = gql`
	query GetPersonalSpaceKeyQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
